"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./dialogs.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BasisDialog = function BasisDialog(_ref) {
  var active = _ref.active,
      className = _ref.className,
      onCloseDialog = _ref.onCloseDialog,
      content = _ref.content,
      title = _ref.title,
      actions = _ref.actions,
      children = _ref.children,
      contentLabel = _ref.contentLabel,
      contentDescription = _ref.contentDescription,
      icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    isOpen: active,
    onRequestClose: onCloseDialog,
    icon: icon,
    contentLabel: contentDescription || contentLabel || '',
    className: "kasasi-dialog ".concat(className),
    overlayClassName: "kasasi-dialog-overlay",
    shouldCloseOnOverlayClick: false,
    ariaHideApp: false
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "title"
  }, title)), icon ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-label"
  }, icon, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, contentLabel, /*#__PURE__*/_react["default"].createElement("div", {
    className: "spacer"
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-container"
  }, children || content), /*#__PURE__*/_react["default"].createElement("div", {
    className: "actions-container"
  }, Array.isArray(actions) ? actions.map(function (action) {
    return action;
  }) : actions));
};

BasisDialog.propTypes = {
  active: _propTypes["default"].bool,
  contentLabel: _propTypes["default"].node,
  contentDescription: _propTypes["default"].string,
  onCloseDialog: _propTypes["default"].func,
  className: _propTypes["default"].string,
  content: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  // either a COMPONENT (<div>) or an array of COMPONENTS ([<KasasiButton>,<KasasiButton>,])
  actions: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)])
};

var noop = function noop() {};

BasisDialog.defaultProps = {
  className: '',
  active: false,
  contentLabel: '',
  contentDescription: '',
  content: '',
  icon: null,
  children: null,
  title: '',
  onCloseDialog: noop,
  // either a COMPONENT (<div>) or an array of COMPONENTS ([<KasasiButton>,<KasasiButton>,])
  actions: []
};
var _default = BasisDialog;
exports["default"] = _default;